export default (node) => {
  /**
   * Data + elements
   */
  let customerTags = node.dataset.customerTagsCourses;
  if (customerTags) {
    customerTags = customerTags.split(',');
  }

  let allVideos = [];
  let allDocs = [];

  /**
   * Functions
   */
  const getAllCoursesVideos = async () => {
    const pageToFetch = '/?sections=get-courses-videos';
    let stopFetch = false;
    let count = 1;
    let response = null;
    let parsedResponse = null;
    let parser = null;
    let videosData = null;
    let nextPage = null;
    let mainData = null;
    let fetchingPage = pageToFetch;

    do {
      try {
        if (count > 1) {
          fetchingPage = fetchingPage + `&page=${count}`;
        }
        response = await fetch(fetchingPage, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        parsedResponse = await response.json();

        if (parsedResponse) {
          let { 'get-courses-videos': getCoursesVideos } = parsedResponse;
          if (getCoursesVideos) {
            parser = new DOMParser();
            mainData = parser.parseFromString(getCoursesVideos, 'text/html');
            videosData = mainData
              ? mainData.querySelector('[data-course-videos]')
              : null;
            videosData = videosData
              ? JSON.parse(videosData.dataset.courseVideos)
              : null;
            if (videosData) {
              allVideos.push(...videosData);
            }
            nextPage = mainData.querySelector('[data-page-next]');
            if (nextPage) {
              fetchingPage =
                nextPage.dataset.pageNext + '&sections=get-courses-videos';
              count++;
            } else {
              stopFetch = true;
            }
          }
        } else {
          stopFetch = true;
        }
      } catch (error) {
        console.error('Error:', error);
        stopFetch = true;
      }
    } while (!stopFetch);

    // dispatch event
    const event = new CustomEvent('courses-videos:loaded');
    document.dispatchEvent(event);
  };

  const getAllCoursesDocs = async () => {
    const pageToFetch = '/?sections=get-courses-docs';
    let stopFetch = false;
    let count = 1;
    let response = null;
    let parsedResponse = null;
    let parser = null;
    let docsData = null;
    let nextPage = null;
    let mainData = null;
    let fetchingPage = pageToFetch;

    do {
      try {
        if (count > 1) {
          fetchingPage = fetchingPage + `&page=${count}`;
        }
        response = await fetch(fetchingPage, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        parsedResponse = await response.json();

        if (parsedResponse) {
          let { 'get-courses-docs': getCoursesDocs } = parsedResponse;
          if (getCoursesDocs) {
            parser = new DOMParser();
            mainData = parser.parseFromString(getCoursesDocs, 'text/html');
            docsData = mainData
              ? mainData.querySelector('[data-course-docs]')
              : null;
            docsData = docsData
              ? JSON.parse(docsData.dataset.courseDocs)
              : null;
            if (docsData) {
              allDocs.push(...docsData);
            }
            nextPage = mainData.querySelector('[data-page-next]');
            if (nextPage) {
              fetchingPage =
                nextPage.dataset.pageNext + '&sections=get-courses-docs';
              count++;
            } else {
              stopFetch = true;
            }
          }
        } else {
          stopFetch = true;
        }
      } catch (error) {
        console.error('Error:', error);
        stopFetch = true;
      }
    } while (!stopFetch);

    // dispatch event
    const event = new CustomEvent('courses-docs:loaded');
    document.dispatchEvent(event);
  };

  const processVideos = () => {
    const customerVideos = [];
    customerTags.forEach((tag) => {
      const videos = allVideos.filter((video) => {
        const videoTitle = video.title.toLowerCase();
        const tagLower = tag.toLowerCase();
        return videoTitle.includes(tagLower);
      });
      customerVideos.push(...videos);
    });

    // render videos

    const template = '#videos-template';
    let templateDiv = document.querySelector(template);
    templateDiv = templateDiv.innerHTML;
    let customTags = ['<%', '%>'];
    Mustache.tags = customTags;
    let videosToRender = {
      info: [],
    };

    allVideos.forEach((video) => {
      videosToRender.info.push({
        vimeo_video: video.vimeo_video,
        title: video.title,
        description: video.description,
      });
    });

    const videosCount = document.querySelector('[data-videos-count]');
    if (videosCount) {
      videosCount.innerHTML = ` (${videosToRender.info.length})`;
    }

    const temp = Mustache.render(templateDiv, videosToRender, {}, customTags);
    document.querySelector('#courses-videos-list').innerHTML = temp;

    // load course Videos component
    const allCoursesVideos = document.querySelectorAll(
      '[data-component="courseVideo"]'
    );
    if (allCoursesVideos) {
      allCoursesVideos.forEach((video) => {
        document.dispatchEvent(
          new CustomEvent('shopify:section:load:course-videos', {
            detail: {
              node: video,
            },
          })
        );
      });
    }
  };

  const processDocs = () => {
    const customerDocs = [];
    let addAllDocs = false;
    if (customerTags.includes('masterclass')) {
      addAllDocs = true;
    }

    customerTags.forEach((tag) => {
      const docs = allDocs.filter((doc) => {
        const docTitle = doc.title.toLowerCase();
        const tagLower = tag.toLowerCase();
        return docTitle.includes(tagLower);
      });
      customerDocs.push(...docs);
    });

    // render docs

    const template = '#docs-template';
    let templateDiv = document.querySelector(template);
    templateDiv = templateDiv.innerHTML;
    let customTags = ['<%', '%>'];
    Mustache.tags = customTags;
    let doscToRender = {
      info: [],
    };

    if (addAllDocs) {
      allDocs.forEach((doc) => {
        doscToRender.info.push({
          title: doc.title,
          url: doc.file,
        });
      });
    } else {
      customerDocs.forEach((doc) => {
        doscToRender.info.push({
          title: doc.title,
          url: doc.file,
        });
      });
    }

    const docsCount = document.querySelector('[data-docs-count]');
    if (docsCount) {
      docsCount.innerHTML = ` (${doscToRender.info.length})`;
    }

    const temp = Mustache.render(templateDiv, doscToRender, {}, customTags);
    document.querySelector('#courses-docs-list').innerHTML = temp;
  };

  const renderVideos = (e) => {
    const videoHandle = e.detail;
    if (videoHandle) {
      const template = '#videos-template';
      let templateDiv = document.querySelector(template);
      templateDiv = templateDiv.innerHTML;
      let customTags = ['<%', '%>'];
      Mustache.tags = customTags;
      let videosToRender = {
        info: [],
      };

      const videoHandleLower = videoHandle.toLowerCase();
      allVideos.forEach((video) => {
        const videoTitle = video.title.toLowerCase();
        if (videoTitle.includes(videoHandleLower)) {
          videosToRender.info.push({
            vimeo_video: video.vimeo_video,
            title: video.title,
            description: video.description,
          });
        }
      });

      const videoContainer = document.querySelector(
        `[data-is-course-video-handle="${videoHandle}"]`
      );
      if (videoContainer) {
        const videoContainerContent = videoContainer.querySelector(
          '[data-courses-accordion-videos-item]'
        );
        const temp = Mustache.render(
          templateDiv,
          videosToRender,
          {},
          customTags
        );
        videoContainerContent.innerHTML = temp;

        // load course Videos component
        const allCoursesVideos = videoContainer.querySelectorAll(
          '[data-component="courseVideo"]'
        );
        if (allCoursesVideos) {
          allCoursesVideos.forEach((video) => {
            document.dispatchEvent(
              new CustomEvent('shopify:section:load:course-videos', {
                detail: {
                  node: video,
                },
              })
            );
          });
        }
      }
    }
  };

  /**
   * Init
   */
  const init = () => {
    getAllCoursesVideos();
    getAllCoursesDocs();

    document.addEventListener('courses-videos:loaded', () => {
      // processVideos();
    });
    document.addEventListener('courses-docs:loaded', () => {
      processDocs();
    });
    document.addEventListener('course-video:open', renderVideos);
  };

  init();
};
